import { connect } from 'react-redux'
import get from 'lodash/get';

const mapStateToProps = (state) => ({
  openResultPage: get(state, ["stepsState", "openResultPage"], false),
});

const mapDispatchToProps = {}

export const withResultPageState = Component => connect(mapStateToProps, mapDispatchToProps)(Component)